import { TextField } from '@material-ui/core';
import React from 'react'
import styles from './item.module.css';
import IconButton from '@material-ui/core/IconButton'
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import SelectComp from '../../../utils/Select/SelectComp';

const Item = (props) => {
    let options= [];
    props.goDown && props.goDown.forEach(val => {
        options.push(val.name) 
    })
    return (
        <div className={styles.container}>
            <h4># {props.index + 1}</h4>

            <SelectComp
                variant="outlined"
                className={styles.textField}
                label="Select GoDown"
                value={props.item.godown}
                onChange={(e) => props.onGoDownChange(e.target.value)}
                options={options}
                values={options} 


                error={props.error && props.error.godown}
                helperText={props.error && props.error.godown}
            />

            <TextField
                variant="outlined"
                className={styles.textField}
                label="Location Name"
                value={props.item.name}
                onChange={(e) => props.onNameChange(e.target.value)}

                error={props.error && props.error.name}
                helperText={props.error && props.error.name}
            />

            <TextField
                variant="outlined"
                className={styles.textField}
                label="Location Barcode"
                disabled
                value={props.item.location_barcode}
                onChange={(e) => props.onCodeChange(e.target.value)}
            /> 

            <IconButton onClick={props.onDelete}>
                <DeleteRoundedIcon />
            </IconButton>
        </div>
    )
}

export default Item;